import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { NumberLiteralType } from "typescript";


export class committeesecratary extends EntityDto implements IEntityDto {
  SecretaryName: string|undefined;
  EmployeeName:string|undefined;
  SecretaryJoiningDateStr:string|null ="";
  Emp_Ref_Id:string|undefined;
  Committee_Id: string;
  Secretary_Emp_Ref_Id: string|undefined;
  SecretaryJoiningDate: Date | undefined;
  SecretaryInChargeTill_Id: number;
  SecretaryInChargeTillDate: Date|undefined;
  SecretaryInChargeTillTenure: number;

  SecretaryTenureDate:string|null='';
  IsActive: boolean;
  SecretaryEditBit:number;
  SecretaryInChargeTillDateStr:string| null ="";
  constructor() {
    super();
    this.SecretaryName = '';  
    this.EmployeeName ="";  
    this.Committee_Id = '00000000-0000-0000-0000-000000000000';
    this.IsActive = true;
    this.Emp_Ref_Id ='';
    this.Secretary_Emp_Ref_Id = '';
    
    this.SecretaryInChargeTill_Id = 0;
    this.SecretaryInChargeTillDate = undefined;
    this.SecretaryInChargeTillTenure = 0;
    this.SecretaryEditBit = 0;
   
    // this.EntityMetaData = [
    //   { FieldName: 'CommitteeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Committee is required' },
    //   // { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Name is required' },
    //   { FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Member is required' },



    // ];
  }
}